<div class="modal-overlay" [class.active]="isOpen" (click)="closeModal()"></div>

<div class="household-modal" [class.open]="isOpen">
  <div class="modal-header">
    <h3>Create New Household</h3>
    <button data-testid="create-household-btn-close" class="close-btn" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
  
  <div class="modal-content">
    <form (ngSubmit)="submitForm()" #householdForm="ngForm">
      <div class="form-group">
        <label for="householdName">Household Name</label>
        <input 
          type="text" 
          id="householdName" 
          data-testid="input-new-household-name"
          name="householdName"
          [(ngModel)]="householdData.HOUSEHOLD_NAME"
          required
          placeholder="Enter household name"
          [disabled]="isSubmitting"
          autofocus
        >
      </div>
      
      <div class="form-actions">
        <button type="button" data-testid="create-household-btn-cancel" class="btn btn-secondary" (click)="closeModal()" [disabled]="isSubmitting">Cancel</button>
        <button type="submit" data-testid="create-household-btn-create" class="btn btn-primary" [disabled]="isSubmitting || !householdData.HOUSEHOLD_NAME">
          <span *ngIf="isSubmitting">Creating...</span>
          <span *ngIf="!isSubmitting">Create Household</span>
        </button>
      </div>
    </form>
  </div>
</div>
